import { FETCH_FORM_SUCCESS } from './';

export default selectedForm => {
  return dispatch => {
    dispatch({ type: FETCH_FORM_SUCCESS, payload: { selectedForm } });
  };
};
